import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { StorageService } from "../storage/storage.service";
@Injectable({ providedIn: "root" })
export class AuthGuardHrUser implements CanActivate {
  constructor(private _router: Router, private storageService: StorageService) { }
  canActivate(): boolean {
    if (this.storageService.secureStorage.getItem("currentUserLogin") == "HrUserLogin") {
      return true;
    } else {
      this._router.navigate([""]);
      return false;
    }
  }
}
